import { CSSProperties, ReactNode } from 'react';
import {
  Box,
  BoxProps,
  Divider,
  IconButton,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDialog } from '@setvi/shared/providers';
import { AIDIalogContainer, AIFooter, AIHeaderContainer } from './styled';
import { SAILogo } from '../logo';
import { SAITitle } from '../title';
import { TextColor } from '../../../enums';
import { AIGradientIcon } from '../../sicons';
import SBackButton from '../../sback-button';

interface AIDIalogContentProps extends Pick<
  BoxProps,
  'width' | 'height' | 'maxWidth' | 'maxHeight'
> {
  children: ReactNode;
  title: string;
  scroll?: boolean;
  button?: JSX.Element;
  description?: string;
  headerDivider?: boolean;
  footerDivider?: boolean;
  containerStyle?: CSSProperties;
  onBack?: () => void;
}

export const SAIDIalogContainer = ({
  children,
  title,
  button,
  description,
  headerDivider = true,
  footerDivider = false,
  containerStyle = {},
  width = '70vw',
  height = '90vh',
  onBack,
  ...rest
}: AIDIalogContentProps) => {
  const { closeDialog } = useDialog();

  return (
    <AIDIalogContainer
      height={height}
      width={width}
      style={containerStyle}
      {...rest}>
      <Box display="flex" flexDirection="column" overflow="hidden" flex={1}>
        <AIHeaderContainer>
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            justifyContent="start">
            <Box display="flex" alignItems="center" gridGap="4px">
              <AIGradientIcon style={{ width: 30, height: 30 }} />
              <SAITitle>{title}</SAITitle>
            </Box>
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gridGap="4px">
              <Box display="flex" alignItems="center" gridGap={8}>
                {onBack && <SBackButton onClick={onBack} />}
                {description && (
                  <Typography
                    style={{
                      fontWeight: 600,
                      fontSize: 20,
                      color: TextColor.Main
                    }}>
                    {description}
                  </Typography>
                )}
              </Box>

              {!!button && button}
            </Box>
          </Box>
          <IconButton
            aria-label="close"
            size="small"
            style={{
              position: 'absolute',
              right: 0,
              transform: 'translate(50%, -50%)'
            }}
            onClick={() => closeDialog()}>
            <CloseIcon />
          </IconButton>
        </AIHeaderContainer>

        {headerDivider && <Divider />}
        <Box
          overflow="hidden auto"
          display="flex"
          width="100%"
          flexDirection="column"
          flex={1}>
          {children}
        </Box>
      </Box>
      <Box>
        {footerDivider && <Divider />}
        <AIFooter>
          <SAILogo />
        </AIFooter>
      </Box>
    </AIDIalogContainer>
  );
};
